import _fromPairs from "lodash/fromPairs";

import BatchReply from "candidate/BatchReply";
import CandidateCheckIn from "candidate/CheckIn";
import EmployeeConversation from "candidate/EmployeeConversation";
import LandingPage from "candidate/AlwaysOn/LandingPage";
import ContactInfoPage from "employee/ContactInfoPage";
import CompanyHub from "hub/CompanyHub";
import Hub from "hub/Hub";
import HubPage from "hub_two_point_o/Hub";
import InformUnsubscribePage from "portal/Retain/Inform/InformUnsubscribePage";
import SmsLandingPage from "portal/Retain/Inform/SMSLandingPage";
import SmsLandingPageHub2 from "portal/Retain/Inform/SMSLandingPageHub2";
import EmployeeRelayProvider from "employee/EmployeeRelayProvider";
import AppContainer from "apps/components/AppContainer";
import checkinStore from "redux/checkin";
import informStore from "redux/inform";
import { emptyStore } from "redux/ws";

import createApp from "./createApp";

// we'll wrap all these with a ProviderType:EmployeeRelayProvider so these can access the employee graphql

const COMPONENT_MAP = {
    ALWAYS_ON_CHECK_IN: {
        Component: LandingPage,
    },
    BATCH_REPLY: {
        Component: BatchReply,
        store: checkinStore,
    },
    CHECK_IN: {
        Component: CandidateCheckIn,
        store: checkinStore,
    },
    COMPANY_HUB: {
        Component: CompanyHub,
        store: checkinStore,
    },
    CONTACT_INFO: {
        Component: ContactInfoPage,
    },
    HUB: {
        Component: Hub,
        store: checkinStore,
    },
    HUB_TWO_POINT_O: {
        Component: HubPage,
        store: checkinStore,
    },
    OPEN_CONVERSATION: {
        Component: EmployeeConversation,
        store: emptyStore,
    },
    RETAIN_INFORM_SMS: {
        Component: SmsLandingPage,
        store: informStore,
    },
    RETAIN_INFORM_SMS_HUB2: {
        Component: SmsLandingPageHub2,
        store: informStore,
    },
    RETAIN_INFORM_UNSUB: {
        Component: InformUnsubscribePage,
        store: informStore,
    },
};

const MAP_WITH_PROVIDER = _fromPairs(
    Object.entries(COMPONENT_MAP).map(([k, e]) => [
        k,
        { ...e, ProviderType: EmployeeRelayProvider },
    ]),
);

export const init = createApp(AppContainer, MAP_WITH_PROVIDER, "employee");
